<template>
    <div class="popup popup--vue" v-bind:class="{'is-active': show}" @click.stop="cancel">
        <div class="popup__content" @click.stop="cancel">
            <div class="popup__header" @click.stop="">
                <div class="title-3">{{title}}</div>
                <button class="popup__close js-popup-close" aria-label="{{button}}" @click.prevent.stop="cancel"></button>
            </div>
            <div class="popup__body py-8 text-center" @click.stop="">
                <div class="note-beta">{{message}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String
            },
            message: {
                type: String
            },
            button: {
                type: String,
            }
        },
        watch: {
            show: function(newVal) {
                if(newVal) {
                    disable_scroll();
                } else {
                    enable_scroll();
                }
            }
        },
        methods: {
            cancel() {
                this.$emit('cancel');
            }
        }
    };
</script>
